import React, { createContext, useMemo, useState } from 'react';
import { TChildren } from '@models/common';

type Props = {
  children: TChildren;
};

type ErrorContextValue = {
  error: string | null;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
};

export const ErrorContext = createContext<ErrorContextValue>({
  error: null,
  setError: () => {},
});

const ErrorProvider: React.FC<Props> = ({ children }) => {
  const [error, setError] = useState<string | null>(null);

  const value = useMemo(
    () => ({
      error,
      setError,
    }),
    [error, setError]
  );

  return (
    <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>
  );
};

export default ErrorProvider;
